import { render, staticRenderFns } from "./WizardView.vue?vue&type=template&id=bd0edbca&scoped=true&"
import script from "./WizardView.vue?vue&type=script&lang=js&"
export * from "./WizardView.vue?vue&type=script&lang=js&"
import style0 from "./WizardView.vue?vue&type=style&index=0&id=bd0edbca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0edbca",
  null
  
)

export default component.exports